import { graphql, useStaticQuery } from "gatsby";

export type Props = {
  allWpPressRelease: {
    nodes: {
      date: string;
      uri: string;
      title: string;
    }[];
  };
};

export const usePressData = (language) => {
  const allWpPressRelease: Props = useStaticQuery(
    graphql`
      {
        sv: allWpPressRelease(sort: {date: DESC}, filter: { language: {code: {in: [SV, EN]}}}) {
          nodes {
            date(formatString: "DD MMM", locale: "Sv")
            uri
            title
          }
        },
        en: allWpPressRelease(sort: {date: DESC}, filter: { language: {code: {eq: EN}}}) {
          nodes {
            date(formatString: "DD MMM", locale: "Sv")
            uri
            title
          }
        },
        no: allWpPressRelease(sort: {date: DESC}, filter: { language: {code: {in: [NO, EN]}}}) {
          nodes {
            date(formatString: "DD MMM", locale: "Sv")
            uri
            title
          }
        }
      }
    `
  );
  return allWpPressRelease[language].nodes;
};
